<template>
	<div>
	<div class="group-card" :style="{flexDirection:(advname.id%2 ==0?'row-reverse':'row')}" v-if="flagtxt">
		<div class="flex-box" :style="{marginLeft:(advname.id%2 ==0?'25px':'0'),marginTop:(advname.id==3||advname.id==4?'20px':'-5px') }">
			<div class="small">
				<div class="small-icon">
				</div>
				{{advname.name}}
			</div>
			<div class="mdjadvText">{{advname.dec}}</div>
		</div>
    	<div class="img-box" :style="{marginLeft:(advname.id%2 ==0?'0':'25px'),top:(advname.id==3||advname.id==4?'100%':''),transform:(advname.id==3||advname.id==4?'translateY(-100%)':'') }">
        <div class="img-mark"></div><img :src="advname.path" alt="advimg" />
		</div>
	</div>
	<!-- // top: 100%;
		// transform: translateY(-100%); -->
	<!-- moblie -->
	<div class="group-card" v-else>
		<div class="flex-box">
			<div class="small">
				<div class="small-icon" v-if="flagtxt">
				</div>
				{{advname.name}}
			</div>
			<div class="down-text">{{advname.dec}}</div>
		</div>
		<div class="img-box"><img :src="advname.path" alt="advimg" /></div>
	</div>
	</div>
</template>

<script>
export default {
	name: 'growCard',
	data() {
		return {
			sci: 0,
			title: '生态落地',
			titleText: 'ECOLOGICAL LANDING',
			techAdvances: [
				{
					path: require('./../assets/images/生态落地/1.png'),
					id: 1
				}
			]
		};
	},
	 props: ["advname","flagtxt"]
};
</script>
<style lang="less" scoped>
.group-card {
	width: 100%;
	height: 170px;
	display: flex;
	flex-direction: row-reverse;
  justify-content: space-between;

	.img-box {
		width: 170px;
		height: 170px;
		position: relative;
		left: 0;
		bottom: 79%;
		transform: translateY(100%);
    .img-mark{
      width: 170px;
      height: 170px;
      position: absolute;
      background: rgba(0, 0, 0, 0.6);
    }
		img {
			width: 100%;
			height: 100%;
		}

	}
	.flex-box {
		flex: 1;
		height: 100%;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		letter-spacing: 5px;
		.small {
			width: 120px;
			height: 20px;
			font-size: 20px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #333333;
			line-height: 36px;
			letter-spacing: 10px;
			margin-bottom: 20px;
			.small-icon{
			width: 20px;
			height:20px;
			background: linear-gradient(138deg, #ee0090 0%, #e84142 100%, #e84142 100%);
			opacity: 0.8;
			display: inline-block;
			}
		}
	}
}
</style>
